<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('name') }}</label>
        <input
          type="text"
          :placeholder="$t('name')"
          v-model.lazy="filter.fullname"
          class="form-control"
          maxlength="255"
        />
      </v-flex>
      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('Channel') }}</label>
        <multiselect
          v-model="filterApp"
          :options="channelOptions"
          label="label"
          selectLabel
          selectedLabel
          :allow-empty="false"
          :searchable="false"
          deselect-label
          track-by="label"
          @select="emitFilterApp"
        ></multiselect>
      </v-flex>
      <v-flex
        xs12
        sm3
        class="form-control pa-1"
        v-if="filterApp.value && ['line'].includes(filterApp.value)"
      >
        <label for>{{ $t('รูปแบบ') }}</label>
        <multiselect
          v-model="filter.app"
          :options="channelOptionsLine"
          label="label"
          selectLabel
          selectedLabel
          :allow-empty="false"
          :searchable="false"
          deselect-label
          track-by="label"
          @select="emitFilterApp"
        ></multiselect>
      </v-flex>
      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('gender') }}</label>
        <multiselect
          v-model="filter.gender"
          :options="genderOptions"
          label="label"
          selectLabel
          selectedLabel
          :allow-empty="false"
          :searchable="false"
          deselect-label
          track-by="label"
        ></multiselect>
      </v-flex>
      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('Locale') }}</label>
        <multiselect
          v-model="filter.locale"
          :options="localeOptions"
          label="title"
          selectLabel
          selectedLabel
          deselect-label
          track-by="value"
          :multiple="true"
          :placeholder="$t('Locale')"
        >
          <template slot="option" slot-scope="props">
            <flag :iso="props.option.icon" />

            {{ props.option.title }}
          </template>
        </multiselect>
      </v-flex>
      <v-flex xs12 sm6 class="form-control pa-1">
        <div>
          <label for>{{ $t('First Conversation at') }}</label>
        </div>
        <template>
          <v-layout>
            <v-flex class="pa-1">
              <datepicker
                v-model="filter.registerDate.start"
                @selected="onRegisterStartDate"
                :placeholder="$t('from')"
                :clear-button="true"
                :clear-button-icon="'fas fa-times'"
              ></datepicker>
            </v-flex>
            <v-flex class="pa-1">
              <datepicker
                v-model="filter.registerDate.end"
                style
                @selected="onRegisterEndDate"
                :placeholder="$t('to')"
                :clear-button="true"
                :clear-button-icon="'fas fa-times'"
              ></datepicker>
            </v-flex>
          </v-layout>
        </template>
      </v-flex>
      <v-flex xs12 sm6 class="form-control pa-1">
        <div>
          <label for>{{ $t('Last Conversation at') }}</label>
        </div>
        <template>
          <v-layout>
            <v-flex class="pa-1">
              <datepicker
                v-model="filter.activeDate.start"
                @selected="onActiveStartDate"
                :placeholder="$t('from')"
                :clear-button="true"
                :clear-button-icon="'fas fa-times'"
              ></datepicker>
            </v-flex>
            <v-flex class="pa-1">
              <datepicker
                v-model="filter.activeDate.end"
                style
                @selected="onActiveEndDate"
                :placeholder="$t('to')"
                :clear-button="true"
                :clear-button-icon="'fas fa-times'"
              ></datepicker>
            </v-flex>
          </v-layout>
        </template>
      </v-flex>
      <v-flex xs12 sm6 md3 class="form-control pa-1">
        <label for>{{ $t('Email') }}</label>
        <input
          type="text"
          :placeholder="$t('Email')"
          v-model.lazy="filter.email"
          class="form-control"
          maxlength="255"
        />
      </v-flex>
      <v-flex xs12 sm6 md3 class="form-control pa-1">
        <label for>{{ $t('phone no.') }}</label>
        <input
          type="text"
          placeholder="Phone No"
          v-model.lazy="filter.phoneno"
          class="form-control"
          maxlength="255"
        />
      </v-flex>
      <!-- <v-flex xs12 sm6 md3 class="form-control pa-1">
        <label for>Message Symbol</label>
        <v-radio-group v-model="filter.messagesent.symbol" row style="margin-top: 5px;">
          <v-radio
            :label="$t('Greater than')"
            :value="{ value: 'g__', label: $t('Greater than')}"
            color="primary"
          ></v-radio>
          <v-radio
            :label="$t('Less than')"
            :value="{value: 'l__',  label: $t('Less than')}"
            color="primary"
          ></v-radio>
        </v-radio-group>
      </v-flex>-->
      <!-- <v-flex xs12 sm6 md3 class="form-control pa-1">
        <label for>{{$t('Message Sent')}}</label>
        <div
          class="form-inline form-control"
          :class="{'has-error': errors.has('filterMessageSentFrom') || errors.has('filterMessageSent')}"
        >
          <input
            type="text"
            class="form-control"
            name="filterMessageSent"
            data-vv-name="filterMessageSent"
            :data-vv-as="$t('Message Sent')"
            :placeholder="$t('Message Sent')"
            v-model="filter.messagesent.value"
            v-validate="'numeric'"
          />

          <p
            class="text-error"
            v-if="errors.has('filterMessageSentFrom')"
          >{{ errors.first('filterMessageSentFrom') }}</p>
          <p
            class="text-error"
            v-else-if="errors.has('filterMessageSent')"
          >{{ errors.first('filterMessageSent') }}</p>
        </div>
      </v-flex>-->

      <v-flex v-if="isBU" xs12 sm6 md3 class="form-control pa-1">
        <label for>{{ $t('LINEID') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('filterLineId') }">
          <input
            type="text"
            class="form-control"
            name="filterLineId"
            data-vv-name="filterLineId"
            :data-vv-as="$t('LINEID')"
            :placeholder="$t('LINEID')"
            v-model.lazy="filter.lineid"
          />

          <p class="text-error" v-if="errors.has('filterLineId')">
            {{ errors.first('filterLineId') }}
          </p>
        </div>
      </v-flex>

      <v-flex v-if="isBU" xs12 sm6 md3 class="form-control pa-1">
        <label for>{{ $t('School') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('School') }">
          <multiselect
            v-model="filter.school"
            :options="allSchools"
            :options-limit="10"
            :loading="isLoading"
            @search-change="asyncFindSchools"
            placeholder="Select one"
            label="name"
            track-by="name"
          ></multiselect>
          <p class="text-error" v-if="errors.has('School')">{{ errors.first('School') }}</p>
        </div>
      </v-flex>

      <v-flex v-if="isBU" xs12 sm6 md3 class="form-control pa-1">
        <label for>{{ $t('Province') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('Province') }">
          <input
            type="text"
            class="form-control"
            name="Province"
            data-vv-name="Province"
            :data-vv-as="$t('Province')"
            :placeholder="$t('Province')"
            v-model.lazy="filter.province"
          />

          <p class="text-error" v-if="errors.has('Province')">{{ errors.first('Province') }}</p>
        </div>
      </v-flex>

      <v-flex xs12 sm6 md3 class="form-control pa-1">
        <label>{{ $t('Context') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('Context') }">
          <multiselect
            v-model="context"
            :options="contextOptions"
            label="label"
            track-by="value"
            selectLabel
            selectedLabel
            deselect-label
            :taggable="true"
            :placeholder="$t('Context')"
            tagPlaceholder="Press to enter to confirm"
            @input="onFilterContext"
            @tag="onTagContext"
            @open="openDropdown()"
            @close="closeDropdown()"
            ref="multiselect"
          ></multiselect>

          <!-- <input
            type="text"
            class="form-control"
            name="Context"
            data-vv-name="Context"
            :data-vv-as="$t('Context')"
            :placeholder="$t('Context')"
            v-model.lazy="filter.context"
          /> -->

          <p class="text-error" v-if="errors.has('Context')">{{ errors.first('Context') }}</p>
        </div>
      </v-flex>

      <v-flex xs12 sm6 md3 class="form-control pa-1">
        <label>{{ $t('Customer Types') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('Context') }">
          <multiselect
            v-model="filter.specialcondition"
            :options="specialconditionOptions"
            :searchable="false"
            label="label"
            track-by="value"
            selectLabel
            selectedLabel
            deselect-label
            :placeholder="$t('Customer Types')"
          ></multiselect>

          <p class="text-error" v-if="errors.has('Province')">{{ errors.first('Province') }}</p>
        </div>
      </v-flex>

      <v-flex xs12 sm6 md 3 class="form-control pa-1">
        <label for>{{ $t('Payment Status') }}</label>
        <multiselect
          v-model="payStatus"
          :options="payOptions"
          label="label"
          :placeholder="$t('Payment Status')"
          selectLabel
          selectedLabel
          :searchable="false"
          multiple
          deselect-label
          track-by="value"
          @input="onInputPayStatus"
        ></multiselect>
      </v-flex>
      <v-flex xs12 sm6 md 3 class="form-control pa-1">
        <label for>{{ $t('Marketing Messages Status') }}</label>
        <multiselect
          v-model="opt_in"
          :options="optInOption"
          label="label"
          :placeholder="$t('Marketing Messages Status')"
          selectLabel
          selectedLabel
          :allow-empty="true"
          :searchable="false"
          deselect-label
          track-by="label"
          @select="onSelectOptIn"
          @remove="onRemoveOptIn"
        ></multiselect>
      </v-flex>
      <v-flex xs12 sm6 md 3 />
      <!-- <v-flex xs12 class="form-control pa-1">
        <label for>{{$t('Conversation')}}</label>
        <multiselect
          v-model="filter.intent"
          :options="filterIntent"
          :searchable="true"
          selectLabel
          selectedLabel
          deselect-label
          :multiple="true"
          :placeholder="$t('Conversation')"
        ></multiselect>
      </v-flex>-->

      <v-flex xs12 class="form-control pa-1" :class="{ 'has-error': errorFilterTag.length > 0 }">
        <label for>{{ $t('Tag') }}</label>
        <span> Include</span>
        <tags
          v-if="tagOptions"
          v-model="includeTag"
          :tags="includeTags"
          :combobox="true"
          :itemOption="tagOptions"
          @tags-changed="addIncludeTags"
          @before-adding-tag="checkTag"
          style="margin-bottom: 10px"
          :btnText="$t('Add tag')"
        ></tags>
        <label for>{{ $t('Tag') }}</label>
        <span> Exclude</span>
        <tags
          v-if="tagOptions"
          v-model="excludeTag"
          :tags="excludeTags"
          :combobox="true"
          :itemOption="tagOptions"
          @tags-changed="addExcludeTags"
          @before-adding-tag="checkTag"
          style="margin-bottom: 10px"
          :btnText="$t('Add tag')"
        ></tags>

        <span class="text-error" v-if="errorFilterTag.length > 0">
          <template v-if="errorFilterTag.includes('overmaxlength')">{{
            $t('Message cannot be longer than 20 alphabets')
          }}</template>
          <template v-else-if="errorFilterTag.includes('duplicate')">{{
            $t('Duplicate Tag')
          }}</template>
        </span>
      </v-flex>
      <v-flex xs12 class="form-control pa-1">
        <label for>{{ $t('Status') }}</label>
        <v-radio-group color="primary" v-model="filter.statustype" row class="text-xs-center">
          <v-radio color="primary" :label="$t('Includes')" :value="'includes'"></v-radio>
          <v-radio color="primary" :label="$t('Excludes')" :value="'excludes'"></v-radio>
        </v-radio-group>
        <multiselect
          v-model="filter.status"
          :options="statusOptions"
          :searchable="true"
          selectLabel
          selectedLabel
          deselect-label
          :multiple="true"
          :placeholder="$t('Status')"
          @select="$emit('onChangeStatus')"
          @remove="$emit('onChangeStatus')"
        ></multiselect>
      </v-flex>
      <v-flex xs12 class="form-control pa-1 mt-1">
        <label for>{{ $t('Select Inbox Keyword') }}</label>
        <multiselect
          v-model="inboxKeyword"
          tag-placeholder="Add Inbox Keyword"
          :placeholder="$t('Select Inbox Keyword')"
          :options="inboxKeyword"
          :multiple="true"
          :taggable="true"
          @tag="addTagInboxKeyword"
          @remove="removeTagInboxKeyword"
        ></multiselect>
      </v-flex>
      <v-flex xs12 class="form-control pa-1 mt-1">
        <label for>{{ $t('Select Comment Keyword') }}</label>
        <multiselect
          v-model="commentKeyword"
          tag-placeholder="Add Comment Keyword"
          :placeholder="$t('Select Comment Keyword')"
          :options="commentKeyword"
          :multiple="true"
          :taggable="true"
          @tag="addTagCommentKeyword"
          @remove="removeTagCommentKeyword"
        ></multiselect>
      </v-flex>
      <!-- Event Purchase Payment -->
      <v-flex xs12 class="pa-1 mt-1">
        <span>{{ $t('total_purchase_amount') }}</span>
      </v-flex>
      <v-flex xs4 class="form-control pa-1 mt-1">
        <label for>{{ $t('minimum_payment_amount') }}</label>
        <input
          type="text"
          class="form-control"
          data-vv-name="minimum_payment_amount"
          :data-vv-as="$t('minimum_payment_amount')"
          :placeholder="$t('minimum_payment_amount')"
          v-model.lazy="filter.filter_event_data_value.min"
        />
      </v-flex>
      <v-flex xs4 class="form-control pa-1 mt-1">
        <label for>{{ $t('maximum_payment_amount') }}</label>
        <input
          type="text"
          class="form-control"
          data-vv-name="maximum_payment_amount"
          :data-vv-as="$t('maximum_payment_amount')"
          :placeholder="$t('maximum_payment_amount')"
          v-model.lazy="filter.filter_event_data_value.max"
        />
      </v-flex>
      <!-- <v-flex xs4 /> -->
      <v-flex xs4 class="pa-1 mt-1">
        <label for>{{ $t('payment_currency') }}</label>
        <v-select
          v-model.lazy="filter.filter_event_data_value.currency"
          :items="$store.state.currencies"
          name="payment_currency"
          data-vv-name="payment_currency"
          :data-vv-as="$t('payment_currency')"
          :placeholder="$t('payment_currency')"
          v-validate="{
            required:
              Boolean(filter.filter_event_data_value.min) ||
              Boolean(filter.filter_event_data_value.max)
          }"
          hide-details
          outline
        />
        <span class="red--text" v-if="errors.has('payment_currency')">
          {{ errors.first('payment_currency') }}
        </span>
      </v-flex>
      <!-- Event Purchase Quantity -->
      <v-flex xs12 class="pa-1 mt-1">
        <span>{{ $t('order_quantity') }}</span>
      </v-flex>
      <v-flex xs4 class="form-control pa-1 mt-1">
        <label for>{{ $t('minimum_quantity') }}</label>
        <input
          type="text"
          class="form-control"
          data-vv-name="minimum_quantity"
          :data-vv-as="$t('minimum_quantity')"
          :placeholder="$t('minimum_quantity')"
          v-model.lazy="filter.filter_event_data_quantity.min"
        />
      </v-flex>
      <v-flex xs4 class="form-control pa-1 mt-1">
        <label for>{{ $t('maximum_quantity') }}</label>
        <input
          type="text"
          class="form-control"
          data-vv-name="maximum_quantity"
          :data-vv-as="$t('maximum_quantity')"
          :placeholder="$t('maximum_quantity')"
          v-model.lazy="filter.filter_event_data_quantity.max"
        />
      </v-flex>
      <v-flex xs4 />
      <!-- <v-flex xs4 class="pa-1 mt-1">
        <label for>{{ $t('payment_currency') }}</label>
        <v-select
          v-model.lazy="filter.filter_event_data_quantity.currency"
          :items="$store.state.currencies"
          name="quantity_currency"
          data-vv-name="quantity_currency"
          :data-vv-as="$t('payment_currency')"
          :placeholder="$t('payment_currency')"
          v-validate="{
            required:
              Boolean(filter.filter_event_data_quantity.min) ||
              Boolean(filter.filter_event_data_quantity.max)
          }"
          hide-details
          outline
        />
        <span class="red--text" v-if="errors.has('quantity_currency')">
          {{ errors.first('quantity_currency') }}
        </span>
      </v-flex> -->
      <!-- Event Purchase Date -->
      <v-flex xs12 class="pa-1 mt-1">
        <span>{{ $t('latest_purchase_date') }}</span>
      </v-flex>
      <v-flex xs4 class="form-control pa-1 mt-1">
        <label for>{{ $t('start_date') }}</label>
        <date-picker v-model="filter.filter_event_data_time.start_at" fullWidth>
          <template v-slot="{ computedDate }">
            <input
              type="text"
              class="form-control"
              data-vv-name="start_date"
              :data-vv-as="$t('start_date')"
              :placeholder="$t('start_date')"
              v-model.lazy="computedDate"
            />
          </template>
        </date-picker>
      </v-flex>
      <v-flex xs4 class="form-control pa-1 mt-1">
        <label for>{{ $t('end_date') }}</label>
        <date-picker v-model="filter.filter_event_data_time.end_at" fullWidth>
          <template v-slot="{ computedDate }">
            <input
              type="text"
              class="form-control"
              data-vv-name="end_date"
              :data-vv-as="$t('end_date')"
              :placeholder="$t('end_date')"
              v-model.lazy="computedDate"
            />
          </template>
        </date-picker>
      </v-flex>
      <!-- <v-flex xs12 class="pa-1 mt-1">
        <div v-if="!isBroadCast" style="text-align: right; color: black; font-size: 1.1em">
          {{ $t('Total') }}:
          <template v-if="total_user != false">{{ total_user | numberFormat }}</template>
          <template v-else>N/A</template> <slot name="refresh_btn"></slot>
        </div>
      </v-flex> -->
    </v-layout>
    <slot name="append" :filter="filter"></slot>
    <div class="text-xs-right pa-1">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import config from '@/config'
import dayjs from 'dayjs'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import datepicker from 'vuejs-datepicker'
import DatePicker from './DatePicker.vue'
import Tags from '@/components/elements/Tags'
import MultiSelectCustom from './MultiSelectCustom.vue'

export default {
  props: ['value', 'total_user', 'isBroadCast'],
  components: {
    Multiselect,
    datepicker,
    Tags,
    MultiSelectCustom,
    DatePicker
  },
  data: function() {
    return {
      statusOptions: [],
      tagOptions: null,
      payStatus: null,
      context: null,
      opt_in: null,
      allSchools: [],
      isLoading: false,
      filter: [],
      filterApp: {},
      channelOptions: [],
      channelOptionsLine: [
        {
          label: this.$t('Friends'),
          value: 'line'
        },
        {
          label: this.$t('Group'),
          value: 'line-group'
        }
      ],
      genderOptions: [
        {
          label: this.$t('All'),
          value: 'all'
        },
        {
          label: this.$t('Male'),
          value: 'male'
        },
        {
          label: this.$t('Female'),
          value: 'female'
        },
        {
          label: this.$t('no gender'),
          value: 'other'
        }
      ],
      payOptions: [
        { value: 'pending', label: this.$t('pending') },
        { value: 'ordered', label: this.$t('ordered') },
        { value: 'paid', label: this.$t('paid') },
        { value: 'shipped', label: this.$t('shipped') },
        { value: 'canceled', label: this.$t('cancel') }
        // // {
        // //   label: this.$t('All'),
        // //   value: ''
        // // },
        // {
        //   label: this.$t('Paid'),
        //   value: 'PAID'
        // },
        // {
        //   label: this.$t('Pending'),
        //   value: 'WAITING'
        // }
      ],
      optInOption: [
        // {
        //   label: this.$t('All'),
        //   value: 'all'
        // },
        {
          label: this.$t('Daily'),
          value: 'daily'
        },
        {
          label: this.$t('Daily (who expired)'),
          value: 'daily_exp'
        }
        // {
        //   label: this.$t('Weekly'),
        //   value: 'weekly'
        // },
        // {
        //   label: this.$t('Montly'),
        //   value: 'montly'
        // }
      ],
      specialconditionOptions: [
        {
          label: this.$t('Active Users'),
          value: 'activeusers'
        },
        {
          label: this.$t('Potential Users'),
          value: 'potentialusers'
        },
        {
          label: this.$t('Purchased Users'),
          value: 'perchasedusers'
        },
        {
          label: this.$t('Loyal Customer'),
          value: 'perchasedusers_royalty'
        },
        {
          label: this.$t('New Customer'),
          value: 'perchasedusers_newcomer'
        }
      ],
      contextOptions: [
        {
          label: this.$t('contactadmin'),
          value: 'contactadmin'
        }
      ],
      contextOptionsDefault: [],
      searchContext: '',
      localeOptions: config.locale,
      symbolOptions: [
        {
          value: 'g__',
          label: this.$t('Greater than')
        },
        {
          value: 'l__',
          label: this.$t('Less than')
        },
        {
          value: 'n__',
          label: this.$t('Not')
        }
      ],
      intents: [],
      errorFilterTag: [],
      includeTag: '',
      excludeTag: '',
      inboxKeyword: [],
      commentKeyword: []
    }
  },
  mounted: async function() {
    const vm = this
    const packages = vm.selectedBot.packages
    if (packages.includes('facebook')) {
      vm.channelOptions.push({
        label: vm.$t('Facebook'),
        value: 'facebook'
      })
    }
    if (packages.includes('line')) {
      vm.channelOptions.push({
        label: vm.$t('Line'),
        value: 'line'
      })
    }
    if (packages.includes('instagram')) {
      vm.channelOptions.push({
        label: vm.$t('Instagram'),
        value: 'instagram'
      })
    }
    if (packages.includes('google')) {
      vm.channelOptions.push({
        label: vm.$t('Google'),
        value: 'google'
      })
    }
    if (this.isBroadCast) {
      this.optInOption = [
        {
          label: this.$t('Daily'),
          value: 'daily'
        }
      ]
    }
    this.getUserTagList()
    this.getUserStatusList()
    this.filter = this.value
    if (!this.filter.hasOwnProperty('fullname')) {
      this.filter.fullname = ''
    }
    if (!this.filter.hasOwnProperty('filter_event_data_value')) {
      this.filter.filter_event_data_value = {}
    }
    if (!this.filter.hasOwnProperty('filter_event_data_quantity')) {
      this.filter.filter_event_data_quantity = {}
    }
    if (!this.filter.hasOwnProperty('filter_event_data_time')) {
      this.filter.filter_event_data_time = {}
    }

    try {
      if (vm.filter.app.value === 'all') {
        vm.filterApp = {
          label: vm.$t('Facebook'),
          value: 'facebook'
        }
        vm.filter.app = {
          label: vm.$t('Facebook'),
          value: 'facebook'
        }
        vm.emitFilterApp(vm.filterApp)
      } else {
        vm.channelOptions.forEach(item => {
          if (vm.filter.app.value === 'line-group' || vm.filter.app === 'line-group') {
            vm.filterApp = {
              label: vm.$t('Line'),
              value: 'line'
            }
            vm.filter.app = {
              label: this.$t('Group'),
              value: 'line-group'
            }
          } else if (vm.filter.app.value === 'line' || vm.filter.app === 'line') {
            vm.filterApp = {
              label: vm.$t('Line'),
              value: 'line'
            }
            vm.filter.app = {
              label: this.$t('Friends'),
              value: 'line'
            }
          } else {
            if (item.value === vm.filter.app.value || item.value === vm.filter.app) {
              vm.filter.app = item
              vm.filterApp = item
            }
          }
        })
      }
    } catch (error) {}

    try {
      let gender = this.genderOptions.find(el => el.value == this.value.gender)
      if (gender) this.filter.gender = gender
      else {
        this.filter.gender = this.genderOptions[0]
      }
    } catch (error) {}
    await this.getIntent()
    //this.$emit('onUpdate')
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      userStatus: 'getUserStatus',
      loadingUserStatus: 'getLoadingUserStatus',
      userTags: 'getUserTags',
      loadingUserTags: 'getLoadingUserTags'
    }),
    isBU() {
      return this.$store.state.pageBU.includes(this.selectedBot.pageid)
    },
    filterIntent: function() {
      var vm = this
      vm.intents.sort(function(a, b) {
        var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
        var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
        if (a.intentname[0] == '{' && a.intentname[a.intentname.length - 1] == '}') {
          return 1
        }
        if (b.intentname[0] == '{' && b.intentname[b.intentname.length - 1] == '}') {
          return -1
        }
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })
      var intents = []
      $.each(vm.intents, function(index, intent) {
        intents.push(intent.intentname)
      })
      return intents
    },
    includeTags: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.tags_include && vm.filter.tags_include !== '') {
          var tags_include = []
          tags_include = vm.filter.tags_include.split(',')
          var result = []
          if (tags_include) {
            tags_include.map(function(tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function(tag, index) {
            result.push(tag.text)
          })
        }
        vm.filter.tags_include = result.join(',')
      }
    },
    excludeTags: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.tags_exclude && vm.filter.tags_exclude !== '') {
          var tags_exclude = []
          tags_exclude = vm.filter.tags_exclude.split(',')
          var result = []
          if (tags_exclude) {
            tags_exclude.map(function(tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function(tag, index) {
            result.push(tag.text)
          })
        }
        vm.filter.tags_exclude = result.join(',')
      }
    }
  },

  methods: {
    emitFilterApp(e) {
      this.$emit('emitFilterApp', e)
    },
    async getUserStatusList() {
      const vm = this
      await vm.$store.dispatch('loadStatus')
      if (vm.userStatus.length > 0) {
        vm.statusOptions = vm.userStatus.map(item => {
          return item.name
        })
      }
    },
    async getUserTagList() {
      const vm = this
      await vm.$store.dispatch('loadTags')

      if (vm.userTags.length > 0) {
        vm.tagOptions = vm.userTags.map(item => {
          return item.name
        })
      } else {
        vm.tagOptions = vm.userTags
      }
    },
    onSelectOptIn(param) {
      this.filter.opt_in = param.value
      this.$emit('onChangeStatus')
    },
    onRemoveOptIn(param) {
      if (this.filter.opt_in === param.value) {
        this.opt_in = null
        this.filter.opt_in = null
        this.$emit('onChangeStatus')
      }
    },
    onFilterContext(param) {
      this.filter.context = param ? param.value : ''
      this.$emit('filterContext', this.filter.context)
    },
    onTagContext(tag) {
      // const findOption = this.contextOptions.find(option => option.value === tag)
      // if (!findOption) {
      //   const newOpt = [...this.contextOptions, { value: tag, label: tag }]
      //   this.contextOptions = [...newOpt]
      // }
      this.context = { label: tag, value: tag }
      this.filter.context = tag
    },
    openDropdown() {
      this.contextOptionsDefault = [...this.contextOptions]
      if (this.contextOptions && this.contextOptions.length && this.context && this.context.value) {
        const findOption = this.contextOptions.find(option => option.value === this.context.value)
        if (findOption) {
          this.searchContext = findOption.label
        } else {
          const newOpt = [
            ...this.contextOptions,
            { value: this.context.value, label: this.context.value }
          ]
          this.contextOptions = [...newOpt]
          this.searchContext = this.context.value
        }
      }
      const multiselect = this.$refs.multiselect
      if (multiselect && this.searchContext) {
        multiselect.updateSearch(this.searchContext)
      }
    },
    closeDropdown() {
      this.searchContext = ''
      this.contextOptions = [...this.contextOptionsDefault]
    },
    onInputPayStatus(status) {
      this.filter.payStatus = status.map(s => s.value)
    },
    asyncFindSchools(data) {
      let vm = this
      if (!vm.allSchools.length && !vm.isLoading) {
        vm.isLoading = true
        api.getschoollist(data, function(error, response) {
          if (error) {
            console.error(error)
          } else {
            vm.allSchools = response.data
            vm.isLoading = false
          }
        })
      }
    },
    checkTag(obj) {
      this.errorFilterTag = []
      if (obj.tag.text.length > 9999) {
        this.errorFilterTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addIncludeTags: function(newTags) {
      this.includeTags = newTags
    },
    addExcludeTags: function(newTags) {
      this.excludeTags = newTags
    },
    addTagInboxKeyword(newTags) {
      this.inboxKeyword.push(newTags)
      this.filter.inbox_keywords = this.inboxKeyword
    },
    addTagCommentKeyword(newTags) {
      this.commentKeyword.push(newTags)
      this.filter.comment_keywords = this.commentKeyword
    },
    removeTagInboxKeyword(newTags) {
      this.filter.inbox_keywords = this.inboxKeyword.filter(item => item !== newTags)
    },
    removeTagCommentKeyword(newTags) {
      this.filter.comment_keywords = this.commentKeyword.filter(item => item !== newTags)
    },
    getIntent: function(callback) {
      let vm = this
      let auth = null
      return new Promise((resolve, reject) => {
        let data = {
          pageid: vm.selectedBot.pageid
        }
        api.getIntent(data, function(error, response) {
          if (error) {
            console.error(error)
            reject(error)
          }
          if (response.data) {
            var isFoundDefault = false
            $.each(response.data, function(index, val) {
              var intent = val
              intent.isShow = false
              vm.intents.push(intent)
            })
          }
          resolve()
        })
      })
    },
    onActiveStartDate: function(value) {
      var vm = this
      if (dayjs(this.filter.activeDate.end).isBefore(value)) {
        this.filter.activeDate.end = value
      }
      this.filter.activeDate.start = value
      this.$emit('onUpdate')
    },
    onActiveEndDate: function(value) {
      var vm = this
      if (dayjs(value).isBefore(this.filter.activeDate.start)) {
        this.filter.activeDate.start = value
      }
      this.filter.activeDate.end = value
      this.$emit('onUpdate')
    },
    onRegisterStartDate: function(value) {
      var vm = this
      if (dayjs(this.filter.registerDate.end).isBefore(value)) {
        this.filter.registerDate.end = value
      }
      this.filter.registerDate.start = value
      this.$emit('onUpdate')
    },
    onRegisterEndDate: function(value) {
      var vm = this
      if (dayjs(value).isBefore(this.filter.registerDate.start)) {
        this.filter.registerDate.start = value
      }
      this.filter.registerDate.end = value
      this.$emit('onUpdate')
    }
  },
  watch: {
    value: function(newVal) {
      this.filter = newVal
      if (!this.filter.hasOwnProperty('fullname')) {
        this.filter.fullname = ''
      }
      try {
        let channel = this.channelOptions.find(el => el.value == newVal.app)
        if (channel) this.filter.app = channel
        else {
          this.filter.app = this.channelOptions[0]
        }
      } catch (error) {
        //
      }
      try {
        let gender = this.genderOptions.find(el => el.value == newVal.gender)
        if (gender) this.filter.gender = gender
        else {
          this.filter.gender = this.genderOptions[0]
        }
      } catch (error) {}
    },
    filterApp: function(newVal) {
      if (newVal.value === 'line') {
        this.filter.app = {
          label: this.$t('Friends'),
          value: 'line'
        }
      } else {
        this.filter.app = newVal
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/FilterCustomer.vue